import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { CMS_POST_API_CONFIG, BlogPostConfig } from '../config';

/**
 * Provides the CMS Post Library with configuration
 * 
 * @param config - Configuration for the blog post library
 * @returns Environment providers for the library
 * 
 * @example
 * ```typescript
 * // In app.config.ts
 * import { provideBlogPostLib } from 'cms-post-lib';
 * import { environment } from './environments/environment';
 * 
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideRouter(routes),
 *     provideHttpClient(withInterceptors([authInterceptor])),
 *     provideBlogPostLib({
 *       apiBaseUrl: environment.cmsApiBaseUrl,
 *       debug: !environment.prod
 *     })
 *   ]
 * };
 * ```
 * 
 * @example
 * ```typescript
 * // In a NgModule
 * import { provideBlogPostLib } from 'cms-post-lib';
 * 
 * @NgModule({
 *   providers: [
 *     provideBlogPostLib({
 *       apiBaseUrl: 'http://localhost:3001'
 *     })
 *   ]
 * })
 * export class AppModule { }
 * ```
 */
export function provideBlogPostLib(config: BlogPostConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: CMS_POST_API_CONFIG,
      useValue: config
    }
  ]);
}

/**
 * Legacy provider function for backwards compatibility
 * 
 * @deprecated Use provideBlogPostLib() instead
 */
export function provideCmsPostLib(config: BlogPostConfig): Provider[] {
  return [
    {
      provide: CMS_POST_API_CONFIG,
      useValue: config
    }
  ];
}
